import { render, staticRenderFns } from "./BranchDetail.vue?vue&type=template&id=47a8f0cc&"
import script from "./BranchDetail.vue?vue&type=script&lang=js&"
export * from "./BranchDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports